import React, { Component } from "react"
import { GridProps } from 'semantic-ui-react';
import styled from 'styled-components';

export const StyledDiv = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-bottom: 5px;
  border-bottom: 1px solid rgba(34,36,38,.1);
  margin-bottom: 0;
`;

class HomeLeftHeader extends Component<GridProps> {

  render(): React.ReactNode {
    const {children, ...rest} = this.props;
    return (
        <StyledDiv {...rest}>
          {children}
        </StyledDiv>
    )
  }
}

export default HomeLeftHeader;
